export default "__VITE_ASSET__48806401__"